import { useContext, useEffect, useRef } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Context } from "../context/Context";
import RoomEquipmentsList from "../components/RoomEquipmentsList";
import RoomNameModal from "../components/modals/RoomNameModal";

const HomePage = () => {
  const {
    page,
    setPage,
    handleEquipmentsListModal,
    authUser,
  } = useContext(Context);

  const containerRef = useRef(null);

  useEffect(() => {
    setPage({
      name: "خانه",
      slug: "home",
    });
    
    // فقط در صورتی که المنت موجود باشه و PerfectScrollbar تعریف شده باشه
    if (containerRef.current && window.PerfectScrollbar) {
      new window.PerfectScrollbar(containerRef.current, {
        wheelSpeed: 0.5,
        scrollYMarginOffset: 0.5,
      });
    }
    
    // cleanup
    return () => {
      if (containerRef.current && containerRef.current.perfectScrollbar) {
        containerRef.current.perfectScrollbar.destroy();
      }
    };
  }, [setPage]);

  return (
    <HelmetProvider>
      <Helmet>
        <title>{page.name}</title>
      </Helmet>
      <div className="container-xxl flex-grow-1 container-p-y">
        <div className="col-12 col-md-10 col-lg-8 w-100 h-100 mx-auto">
          <div
            className="card h-100"
            style={{ backgroundColor: "#fff0", boxShadow: "none" }}
          >
            <div className="card-header d-flex align-items-center justify-content-between border-bottom mb-3 p-0 pt-2" style={{ zIndex: "1" }}>
              <h4></h4>
              {authUser?.is_admin ? (
                <button
                  type="button"
                  className="btn btn-icon btn-success-app mt-2"
                  onClick={() => handleEquipmentsListModal(true)}
                >
                  <i className="bx bx-plus"></i>
                </button>
              ) : null}
            </div>
            <div className="card-body scrollbar" ref={containerRef}>
              <div className="d-flex flex-wrap justify-content-around justify-content-sm-start">
                <RoomEquipmentsList />
              </div>
            </div>
          </div>
        </div>
      </div>
    </HelmetProvider>
  );
};

export default HomePage;